/* eslint-disable jsx-a11y/alt-text */
import yellow from '../../images/yellow.svg';

export const YellowCard = () => (
  <img src={yellow} width={14} height={14} />
)
